import { createBlock } from '@lcifr/portable';
import { Lead } from './Lead';

export const LeadMark = createBlock(/styleLead/, ({ children }) => {
  return <Lead>{children}</Lead>;
});
